/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WorkstreamHealthScoreContextResponse } from '../models/WorkstreamHealthScoreContextResponse';
import type { WorkstreamHealthScoreCsvExportRequest } from '../models/WorkstreamHealthScoreCsvExportRequest';
import type { WorkstreamHealthScoreGenerateRequest } from '../models/WorkstreamHealthScoreGenerateRequest';
import type { WorkstreamHealthScoreResponse } from '../models/WorkstreamHealthScoreResponse';
import type { WorkstreamHealthScoresResponse } from '../models/WorkstreamHealthScoresResponse';
import type { WorkstreamHealthScoreStatusResponse } from '../models/WorkstreamHealthScoreStatusResponse';
import type { WorkstreamHealthScoreTaskResponse } from '../models/WorkstreamHealthScoreTaskResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AiWorkstreamHealthScoreService {

    /**
     * Generate Workstream Health Score
     * Kick off async generation for comprehensive AI workstream health score.
     * Returns a task_id to poll for completion.
     *
     * Frontend must provide workstream ID and optionally checks_type and timeframe.
     * Workstream ID must be in the list of enabled workstream IDs.
     * @param requestBody
     * @returns WorkstreamHealthScoreTaskResponse Successful Response
     * @throws ApiError
     */
    public static generateWorkstreamHealthScoreApiV1WorkstreamHealthScoreGeneratePost(
        requestBody: WorkstreamHealthScoreGenerateRequest,
    ): CancelablePromise<WorkstreamHealthScoreTaskResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/health_score/generate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Workstream Health Score Status
     * Poll for workstream health score generation status.
     * @param taskId
     * @returns WorkstreamHealthScoreStatusResponse Successful Response
     * @throws ApiError
     */
    public static getWorkstreamHealthScoreStatusApiV1WorkstreamHealthScoreGenerateTaskIdGet(
        taskId: string,
    ): CancelablePromise<WorkstreamHealthScoreStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/health_score/generate/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Check Workstream Health Score Enabled
     * Check if workstream health score feature is enabled for a workstream.
     * Returns true if the workstream is in the list of enabled workstream IDs.
     * @param id
     * @param timeframe
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static checkWorkstreamHealthScoreEnabledApiV1WorkstreamIdHealthScoreEnabledGet(
        id: number,
        timeframe?: (string | null),
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{id}/health_score/enabled',
            path: {
                'id': id,
            },
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Workstream Health Score
     * Get AI-generated comprehensive workstream health score.
     * Returns the health score from WorkstreamHealthScore table if available.
     * Use POST to generate/refresh.
     *
     * Only available for workstreams in the list of enabled workstream IDs.
     * @param id
     * @param checksType
     * @param timeframe
     * @returns WorkstreamHealthScoreResponse Successful Response
     * @throws ApiError
     */
    public static getWorkstreamHealthScoreApiV1WorkstreamIdHealthScoreGet(
        id: number,
        checksType: string,
        timeframe?: (string | null),
    ): CancelablePromise<WorkstreamHealthScoreResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{id}/health_score',
            path: {
                'id': id,
            },
            query: {
                'checks_type': checksType,
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Workstream Health Scores
     * @param checksType
     * @param timeframe
     * @returns WorkstreamHealthScoresResponse Successful Response
     * @throws ApiError
     */
    public static getWorkstreamHealthScoresApiV1WorkstreamHealthScoresGet(
        checksType: string = 'default',
        timeframe?: (string | null),
    ): CancelablePromise<WorkstreamHealthScoresResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/health_scores',
            query: {
                'checks_type': checksType,
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Export Workstream Health Scores Csv Post
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static exportWorkstreamHealthScoresCsvPostApiV1WorkstreamHealthScoresCsvPost(
        requestBody: WorkstreamHealthScoreCsvExportRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/health_scores/csv',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Check Workstream Health Score Context
     * @param id
     * @param checksType
     * @param timeframe
     * @returns WorkstreamHealthScoreContextResponse Successful Response
     * @throws ApiError
     */
    public static checkWorkstreamHealthScoreContextApiV1WorkstreamIdHealthScoreContextGet(
        id: number,
        checksType: string = 'oceo',
        timeframe?: (string | null),
    ): CancelablePromise<WorkstreamHealthScoreContextResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/{id}/health_score/context',
            path: {
                'id': id,
            },
            query: {
                'checks_type': checksType,
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
